import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { importCottagesAction } from "../actions/cottageActions";
import "../style/ImportComponents.css";

const ImportExcelCottages = () => {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.importCottage);
  const [file, setFile] = useState(null);
  const [validationError, setValidationError] = useState("");

  const handleImport = (event) => {
    event.preventDefault();
    if (!file) {
      setValidationError("ابتدا فایل اکسل را انتخاب کنید.");
      return;
    }
    setValidationError("");
    dispatch(importCottagesAction(file));
  };

  return (
    <section className="import-container" dir="rtl">
      <h3>درون‌ریزی اظهارنامه‌های وارداتی از اکسل</h3>
      <form onSubmit={handleImport}>
        <label htmlFor="cottage-import-file">فایل اکسل</label>
        <input id="cottage-import-file" type="file" accept=".xlsx,.xls"
          onChange={(event) => { setFile(event.target.files?.[0] || null); setValidationError(""); }}
          className="file-input" />
        <button type="submit" className="import-button" disabled={loading}>
          {loading ? "در حال بارگذاری..." : "بارگذاری فایل"}
        </button>
      </form>
      {validationError && <p role="alert" className="error-message">{validationError}</p>}
      {error && <p role="alert" className="error-message">{error}</p>}
      {success && <p role="status" className="success-message">{success}</p>}
    </section>
  );
};

export default ImportExcelCottages;
